import React, { useEffect, useState } from "react";
import Cartstatus from "../cart/Cartstatus";
import Cartform from "../cart/Cartform";
import { useTranslation } from "react-i18next";
import API from "../../api/client";
import * as ENDPOINTS from "../../api/endpoints";
import CustomCurrencyFormat from "../utils/CurrencyFormat";
import { useAuth } from "../../hooks/customers/AuthProvider";

function Carttotal(props) {
  const auth = useAuth();
  const customerId = auth.customer._id;

  const [gst, setGST] = useState(0);
  const { t } = useTranslation();
  const { subtotal, grand_total, tax_amount, discount } = props.cartData;
  const [defaultShipping, setDefaultShipping] = useState(0);
  const [customerData, setCustomerData] = useState(null);

  // const customerShipping = props?.customer?.shipping_cost?.$numberDecimal;
  const customerShipping =
    customerData?.shipping_cost?.$numberDecimal;

  const shipping =
    customerShipping !== undefined && customerShipping !== null
      ? parseFloat(customerShipping)
      : defaultShipping;
  const [applyBlossoms, setApplyBlossoms] = useState(false);
  const [percentage, setPercentage] = useState([]);
  const [dollarstotal, setDollarsTotal] = useState(false);

  useEffect(() => {
    getgstbyYear();
  }, []);

  useEffect(() => {
    if (customerId) {
      fetchCustomerDetails();
    }
  }, [customerId]);

  const fetchCustomerDetails = async () => {
    try {
      const res = await API.get(`${ENDPOINTS.GET_CUSTOMER_DETAILS}/${customerId}`);
      setCustomerData(res.data.data.customer);
    } catch (error) {
      console.error("Error fetching customer:", error);
    }
  };

  const getgstbyYear = async () => {
    let url = `${ENDPOINTS.GET_GST}`;

    const response = await API.get(url);
    if (response.statusText === "OK") {
      setGST(response.data.data);
    }
  };
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await API.get(ENDPOINTS.GET_SETTINGS);
        console.log("Settings response:", response);
        if (response.status === 200) {

          const shipping =
            response?.data?.data?.shipping_cost?.$numberDecimal || 0;

          setDefaultShipping(parseFloat(shipping));
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetchSettings();
  }, []);

  return (
    <div className="cartmain_r customscroll">
      <div className="cart_grandtotal">
        <div className="cart_grandtotal_one">
          <div className="cart_grandtotal_onelist">
            <div className="cart_grandtotal_onelist_l">
              <p>
                <span>{t("subtotal_txt")}</span>
                <CustomCurrencyFormat amount={subtotal} />
              </p>
              <p>
                <span>
                  {t("discount_txt")} (
                  {props.customer.discount["$numberDecimal"]}%)
                </span>
                <span>- <CustomCurrencyFormat amount={discount} /></span>
              </p>
              <p>
                <span>{t("deliveryfee_txt")}</span>
                <span><CustomCurrencyFormat amount={shipping} /></span>
              </p>
              <p>
                <span>
                  {t("gst_txt")} {gst}%
                </span>
                <CustomCurrencyFormat amount={tax_amount} />
              </p>
            </div>
            <div className="cart_grandtotal_onelist_r">
              <p>{t("grandtotal_txt")}</p>
              <p>
                <CustomCurrencyFormat amount={grand_total} />
              </p>
            </div>
          </div>
        </div>
        {/* <Cartform cartData={props.cartData} /> */}
        <Cartform cartData={{ ...props.cartData, shipping }} />
      </div>
      <Cartstatus />
    </div>
  );
}

export default Carttotal;
